const byPrintInstanceTicketsFilter = function (orderItems) {
    return orderItems.filter((orderItem) => orderItem.item.printTicketPerInstance);
};

/* istanbul ignore next */
if (typeof module !== 'undefined' && module.exports) {
    module.exports = byPrintInstanceTicketsFilter;
}
